module.exports = __webpack_public_path__ + "img/card_red.4eb02e03.png";